import { Pipe, PipeTransform } from '@angular/core';
import { parse, format } from '../phone-numbers/phone-number.service';

@Pipe({ name: 'phoneNumber' })
export class PhoneNumberPipe implements PipeTransform {
  transform(value) {
    if (value) {
      const parsedNumber = parse(value);
      if (parsedNumber.phone) {
        return format(parsedNumber, 'National');
      }
      return value;
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/pipes/phone-number.pipe.ts